export default __webpack_public_path__ + "static/media/eric.png.webp";